import { render } from "./HrAssesment.vue?vue&type=template&id=13ced2fd&scoped=true"
import script from "./HrAssesment?vue&type=script&lang=js"
export * from "./HrAssesment?vue&type=script&lang=js"

import "./HrAssesment.vue?vue&type=style&index=0&id=13ced2fd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ced2fd"]])

export default __exports__